import { SignIn, useAuth } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";
import Header from "../components/Header.jsx";

/**
 * /admin/login — Clerk-powered sign-in if VITE_CLERK_PUBLISHABLE_KEY is set.
 * If Clerk isn't configured (no publishable key), falls back to a notice with
 * setup instructions so Mark can wire it later.
 */
export default function AdminLogin() {
  const hasClerk = Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

  // If Clerk is configured, render its SignIn component
  if (hasClerk) {
    return <ClerkSignIn />;
  }
  return <NotConfigured />;
}

function ClerkSignIn() {
  const { isLoaded, isSignedIn } = useAuth();
  if (isLoaded && isSignedIn) {
    return <Navigate to="/admin" replace />;
  }
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div>
          <h1 className="text-3xl font-bold mb-2 text-center">Admin sign-in</h1>
          <p className="text-white/60 mb-8 text-sm text-center max-w-sm mx-auto">
            Reviews dashboard is restricted to The AIE Network admins.
          </p>
          <SignIn
            routing="path"
            path="/admin/sign-in"
            signUpUrl="/admin/sign-in"
            forceRedirectUrl="/admin"
            fallbackRedirectUrl="/admin"
          />
        </div>
      </main>
    </div>
  );
}

function NotConfigured() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-2xl mx-auto w-full px-6 py-24">
        <h1 className="text-3xl font-bold mb-4">Admin not configured</h1>
        <p className="text-white/70 mb-6">
          Auth is provided by{" "}
          <a className="text-flame underline" href="https://clerk.com" target="_blank" rel="noopener">Clerk</a>.
          To enable the admin dashboard:
        </p>
        <ol className="text-white/80 text-sm space-y-3 list-decimal pl-5">
          <li>
            Create a free app at <a className="text-flame underline" href="https://dashboard.clerk.com" target="_blank" rel="noopener">dashboard.clerk.com</a>
          </li>
          <li>
            Copy the <code className="text-flame">Publishable key</code> and{" "}
            <code className="text-flame">Secret key</code>
          </li>
          <li>
            In Vercel → Project Settings → Environment Variables, add:
            <pre className="mt-2 p-3 rounded bg-white/5 text-xs overflow-x-auto">
{`VITE_CLERK_PUBLISHABLE_KEY=pk_live_...
CLERK_SECRET_KEY=sk_live_...`}
            </pre>
          </li>
          <li>Redeploy. /admin/login will then show Clerk's sign-in.</li>
          <li>
            Restrict who can sign in: in Clerk → Restrictions, allow only
            your email domains (peripety.com, theaie.net) or invite specific users.
          </li>
        </ol>
      </main>
    </div>
  );
}
